import {useQuery} from "react-query";
import FiltreLocalisation from "../models/interfaces/dtos/filtre-localisation-dto";
import { fetchItem } from "../queries/queries-helper";
import ENDPOINTS from "../services/endpoints";
import useAuthenticationContext from "../services/context/authentication/use-authentication-context.ts";

const useFilters = () => {
    const { authenticationResponse } = useAuthenticationContext();
    
    return useQuery<FiltreLocalisation[]>(
        "filters",
        async () => {
            const data = await fetchItem<FiltreLocalisation[]>(ENDPOINTS.FILTERS);
            return data ?? [];
        }, 
        {
            enabled: !!authenticationResponse,
            staleTime: 60 * 60 * 1000, // 1 heure
        }
    );
};

export default useFilters;
